export const environment = {
    production: false,
    api_url: 'https://devapi.helpmulte24.it/api/v1'
};
